exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#backIcon[data-v-03f4d726]{margin:.8rem 0rem 0rem;font-size:.9rem\n}\n.rule[data-v-03f4d726]{line-height:1rem;padding:0 1.25rem 1rem;background:#fff;min-height:100vh;font-size:.7rem\n}\n.rule b[data-v-03f4d726]{font-size:.8rem;padding:0rem 0 1rem;line-height:3rem\n}\n", "", {"version":3,"sources":["/bitnami/jenkins/home/workspace/web-app.superex.com/src/view/rules.vue"],"names":[],"mappings":";AAAA,2BAAU,uBAAuB,eAAe;CAAC;AAAA,uBAAM,iBAAiB,uBAAuB,gBAAgB,iBAAiB,eAAe;CAAC;AAAA,yBAAQ,gBAAgB,oBAAoB,gBAAgB;CAAC","file":"rules.vue","sourcesContent":["#backIcon{margin:.8rem 0rem 0rem;font-size:.9rem}.rule{line-height:1rem;padding:0 1.25rem 1rem;background:#fff;min-height:100vh;font-size:.7rem}.rule b{font-size:.8rem;padding:0rem 0 1rem;line-height:3rem}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03f4d726","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/rules.vue
// module id = B8Fw
// module chunks = 0